import React, { useState } from 'react';
import '../style/GalleryStyles.css';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Import all images from assets
  const images = [
    require('../assets/QueenNail/IMG_3651.jpg'),
    require('../assets/QueenNail/IMG_3652.jpg'),
    require('../assets/QueenNail/IMG_3653.jpg'),
    require('../assets/QueenNail/IMG_3654.jpg'),
    require('../assets/QueenNail/IMG_3655.jpg'),
    require('../assets/QueenNail/IMG_3656.jpg'),
    require('../assets/QueenNail/IMG_3657.jpg'),
    require('../assets/QueenNail/IMG_3658.jpg'),
    require('../assets/QueenNail/IMG_3659.jpg'),

    require('../assets/QueenNail/IMG_3458.jpg'),
    require('../assets/QueenNail/IMG_3465.jpg'),
    require('../assets/QueenNail/IMG_3633.jpg'),
    require('../assets/QueenNail/IMG_3662.jpg'),
    require('../assets/QueenNail/IMG_3982.png'),
    require('../assets/QueenNail/IMG_4185.jpg'),
    require('../assets/QueenNail/IMG_4214.jpg'),
    require('../assets/QueenNail/IMG_4220.png'),
    require('../assets/QueenNail/IMG_4237.jpg'),
    require('../assets/QueenNail/download.png'),
    require('../assets/QueenNail/download (1).png'),
    require('../assets/QueenNail/download (2).png'),
    require('../assets/QueenNail/download (3).png'),

   

  ];

  const openImage = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
  };

  const closeImage = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'unset'; // Restore scrolling
  };

  return (
    <div className="gallery-container">
      <h2></h2>
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div key={index} className="gallery-item" onClick={() => openImage(image)}>
            <img src={image} alt={`Gallery item ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Image Overlay */}
      {selectedImage && (
        <div className="image-overlay" onClick={closeImage}>
          <span className="close-button">&times;</span>
          <img 
            src={selectedImage} 
            alt="Full resolution" 
            className="overlay-image"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking the image
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;
